import { inputCls, labelCls } from "./constants";

/**
 * Edycja tekstów podstron: Kontakt, Zamów SIM, Przenieś numer.
 * Sekcje "success_*" dotyczą ekranów potwierdzenia po złożeniu formularza.
 */
export default function OtherPagesSection({ pages, setPages }) {
  const contact = pages.contact || {};
  const orderSim = pages.order_sim || {};
  const portNumber = pages.port_number || {};

  const setContact = (field) => (e) =>
    setPages({ ...pages, contact: { ...contact, [field]: e.target.value } });
  const setOrderSim = (field) => (e) =>
    setPages({ ...pages, order_sim: { ...orderSim, [field]: e.target.value } });
  const setPort = (field) => (e) =>
    setPages({ ...pages, port_number: { ...portNumber, [field]: e.target.value } });

  const Field = ({ testid, label, value, onChange, textarea = false, placeholder = "" }) => (
    <label className="block">
      <span className={labelCls}>{label}</span>
      {textarea ? (
        <textarea
          data-testid={testid}
          value={value || ""}
          onChange={onChange}
          rows={3}
          className={inputCls}
          placeholder={placeholder}
        />
      ) : (
        <input
          data-testid={testid}
          value={value || ""}
          onChange={onChange}
          className={inputCls}
          placeholder={placeholder}
        />
      )}
    </label>
  );

  return (
    <div data-testid="other-pages-section" className="space-y-6">
      {/* Kontakt */}
      <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-4">
        <h3 className="font-display text-lg font-bold text-slate-800">Podstrona „Kontakt"</h3>
        <div className="grid sm:grid-cols-3 gap-4">
          <Field testid="oc-contact-eyebrow" label="Nadtytuł (eyebrow)" value={contact.eyebrow} onChange={setContact("eyebrow")} placeholder="Kontakt" />
          <Field testid="oc-contact-title" label="Nagłówek" value={contact.title} onChange={setContact("title")} placeholder="Porozmawiajmy" />
          <Field testid="oc-contact-subtitle" label="Podtytuł" value={contact.subtitle} onChange={setContact("subtitle")} textarea placeholder="Krótki opis..." />
        </div>
      </div>

      {/* Zamów SIM */}
      <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-4">
        <h3 className="font-display text-lg font-bold text-slate-800">Podstrona „Zamów kartę SIM"</h3>
        <div className="grid sm:grid-cols-3 gap-4">
          <Field testid="oc-sim-eyebrow" label="Nadtytuł (eyebrow)" value={orderSim.eyebrow} onChange={setOrderSim("eyebrow")} placeholder="Zamów kartę SIM" />
          <Field testid="oc-sim-title" label="Nagłówek" value={orderSim.title} onChange={setOrderSim("title")} placeholder="Karta SIM z dostawą" />
          <Field testid="oc-sim-subtitle" label="Podtytuł" value={orderSim.subtitle} onChange={setOrderSim("subtitle")} textarea placeholder="Krótki opis..." />
        </div>
        <div className="pt-3 border-t border-slate-100">
          <div className="text-xs font-bold text-slate-600 mb-2">Ekran potwierdzenia po złożeniu zamówienia:</div>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field testid="oc-sim-success-title" label="Tytuł potwierdzenia" value={orderSim.success_title} onChange={setOrderSim("success_title")} placeholder="Dziękujemy za zamówienie!" />
            <Field testid="oc-sim-success-message" label="Treść potwierdzenia" value={orderSim.success_message} onChange={setOrderSim("success_message")} textarea placeholder="Zapisz ten numer..." />
          </div>
        </div>
        <div className="pt-3 border-t border-slate-100">
          <div className="text-xs font-bold text-slate-600 mb-2">Wybór typu numeru (tylko przy abonamentach telefonicznych):</div>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field testid="oc-sim-number-type-title" label="Nagłówek sekcji" value={orderSim.number_type_title} onChange={setOrderSim("number_type_title")} placeholder="Numer telefonu" />
            <Field testid="oc-sim-number-type-new" label="Etykieta „nowy numer”" value={orderSim.number_type_new_label} onChange={setOrderSim("number_type_new_label")} placeholder="Nowy numer telefonu" />
            <Field testid="oc-sim-number-type-port" label="Etykieta „przenieś numer”" value={orderSim.number_type_port_label} onChange={setOrderSim("number_type_port_label")} placeholder="Przenieś numer telefonu" />
            <Field testid="oc-sim-number-type-port-help" label="Opis pod polem „obecny numer”" value={orderSim.number_type_port_help} onChange={setOrderSim("number_type_port_help")} textarea placeholder="Podaj numer, który chcesz przenieść..." />
          </div>
        </div>
      </div>

      {/* Przenieś numer */}
      <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-4">
        <h3 className="font-display text-lg font-bold text-slate-800">Podstrona „Przenieś numer"</h3>
        <div className="grid sm:grid-cols-3 gap-4">
          <Field testid="oc-port-eyebrow" label="Nadtytuł (eyebrow)" value={portNumber.eyebrow} onChange={setPort("eyebrow")} placeholder="Przeniesienie numeru" />
          <Field testid="oc-port-title" label="Nagłówek" value={portNumber.title} onChange={setPort("title")} placeholder="Zatrzymaj swój numer" />
          <Field testid="oc-port-subtitle" label="Podtytuł" value={portNumber.subtitle} onChange={setPort("subtitle")} textarea placeholder="Krótki opis..." />
        </div>
        <div className="pt-3 border-t border-slate-100">
          <div className="text-xs font-bold text-slate-600 mb-2">Ekran potwierdzenia po złożeniu wniosku:</div>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field testid="oc-port-success-title" label="Tytuł potwierdzenia" value={portNumber.success_title} onChange={setPort("success_title")} placeholder="Wniosek przyjęty!" />
            <Field testid="oc-port-success-message" label="Treść potwierdzenia" value={portNumber.success_message} onChange={setPort("success_message")} textarea placeholder="Zapisz ten numer..." />
          </div>
        </div>
      </div>
    </div>
  );
}
